module.exports = __webpack_public_path__ + "media/images/bank_images/sicoob-add3a3374ac4cea93014c8e6453f38c6.png";